// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #e84200;
    --red: #fa2d00;
    --grey1: #d7d7d7;
    --grey2: #d9d9d9;
    --grey4: #a1a1a1;
    --darkgrey1: #222222;
    --darkgrey3: #000000;
    --white: #ffffff;
}

.signup-page {
    max-width: 1200px;
    margin: 40px auto;
    padding: 20px;
    font-family: 'Noto Sans KR', sans-serif;
}

.sup-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.sup-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.sup-main-title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
}

/* Progress Indicator - 동일한 스타일을 CustomOrderPage와 공유 */
.co-progress-indicator {
    width: 466px;
    max-width: 100%;
    height: 90px;
    position: relative;
    margin: 40px auto;
    padding: 0;
}

.co-progress-line-bg {
    background: #d9d9d9;
    width: calc(100% - 25px);
    height: 3px;
    position: absolute;
    left: 12.5px;
    right: 12.5px;
    top: 12px;
    z-index: 1;
}

.co-progress-line-fill {
    background: var(--primary, #e84200);
    width: 0;
    height: 3px;
    position: absolute;
    left: 12.5px;
    top: 12px;
    z-index: 2;
    transition: width 0.3s ease;
}

.co-progress-line-fill.step1 {
    width: 0;
}

.co-progress-line-fill.step2 {
    width: calc(50% - 12.5px);
}

.co-progress-line-fill.step3 {
    width: calc(100% - 25px);
}

.co-progress-indicator .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    z-index: 3;
    width: auto;
}

/* step-item 순서: (1)line-bg, (2)line-fill, (3)정보입력, (4)입력 내용 확인, (5)접수완료 */
.co-progress-indicator .step-item:nth-child(3) {
    left: 0;
    top: 0;
}

.co-progress-indicator .step-item:nth-child(4) {
    left: 50%;
    transform: translateX(-50%);
    top: 0;
}

.co-progress-indicator .step-item:nth-child(5) {
    right: 0;
    left: auto;
    top: 0;
}

.step-dot {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--grey2, #d9d9d9);
    flex-shrink: 0;
    position: relative;
    margin-bottom: 20px;
}

.co-progress-indicator .step-item.active .step-dot,
.step-dot.active {
    background: var(--primary, #e84200);
}

.step-label {
    color: var(--darkgrey3, #000000);
    text-align: center;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    min-width: 100px;
    margin-left: -40px;
}

.sup-form-section {
    margin-bottom: 50px;
}

.sup-section-title {
    font-size: 20px;
    font-weight: bold;
    border-left: 4px solid #E84100;
    padding-left: 10px;
    margin-bottom: 20px;
}

.sup-form-grid, .sup-summary-grid {
    border-top: 2px solid #333;
    border-bottom: 1px solid #ddd;
}

.sup-form-row, .sup-summary-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    align-items: center;
    border-bottom: 1px solid #eee;
}
.sup-summary-row:last-child {
    border-bottom: none;
}

.sup-form-row label, .sup-summary-row .label {
    background-color: #f9f9f9;
    padding: 20px;
    font-weight: bold;
    align-self: stretch;
    display: flex;
    align-items: center;
}

.sup-form-row .req {
    color: #E84100;
    margin-left: 4px;
}

.sup-form-row .sup-form-field, .sup-form-row input, .sup-form-row div, .sup-form-row select, .sup-summary-row span:last-child {
    padding: 0;
}

.sup-form-row input, .sup-form-row select {
    width: 100%;
    max-width: 350px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0 10px;
}

.sup-form-row .sup-form-field {
    padding: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

/* 우편번호란: 다른 인풋 행과 동일한 좌측 패딩 유지 */
.sup-form-row.sup-zip-row .sup-form-field {
    padding-left: 0;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.sup-form-row.sup-zip-row .sup-form-field input {
    flex: 1 1;
    min-width: 0;
    margin: 0;
}

.sup-btn-inline {
    background-color: #333;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
}

.biz-num input { width: 100px; }
.biz-num .label-after { margin-left: 20px; }

.phone-field input { width: 150px; }
.phone-field .label-after { margin: 0 10px 0 20px; }


.static-field {
    gap: 20px !important;
}
.static-field p {
    font-size: 14px;
    color: #888;
    margin: 0;
}
.sup-form-row .sup-field-note {
    grid-column: 2 / 3;
    padding-left: 20px;
    padding-bottom: 10px;
}

.sup-field-note ul {
    list-style-type: '•';
    padding-left: 20px;
    margin: 0;
    color: #888;
    font-size: 14px;
    line-height: 1.6;
}


.sup-actions {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    gap: 15px;
}

.sup-actions.space-between {
    justify-content: space-between;
}

.sup-btn-primary {
    background-color: #E84100;
    color: white;
    padding: 15px 80px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.sup-btn-dark {
    background-color: #333;
    color: white;
    padding: 15px 60px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.sup-final-container {
    text-align: center;
    padding: 100px 0;
}
.sup-final-container h2 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}
.sup-final-container p {
    font-size: 16px;
    color: #666;
    margin-bottom: 5px;
}
.sup-final-container button {
    margin-top: 40px;
    margin-right: 10px;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .signup-page {
        margin: 20px auto;
    }

    .sup-main-title {
        font-size: 28px;
    }

    .sup-form-row, .sup-summary-row {
        grid-template-columns: 150px 1fr;
    }

    .sup-form-row input, .sup-form-row select {
        max-width: 300px;
    }

    .sup-actions {
        margin-top: 40px;
    }

    .sup-btn-primary {
        padding: 12px 60px;
    }

    .sup-btn-dark {
        padding: 12px 40px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .signup-page {
        padding: 15px;
        margin: 15px auto;
    }

    .sup-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .sup-main-title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    /* 모바일에서도 데스크탑과 동일한 스타일 유지 */
    .co-progress-indicator {
        width: 466px;
        max-width: 100%;
        height: 90px;
        margin: 40px auto;
    }
    
    .co-progress-line-bg {
        width: calc(100% - 25px);
        left: 12.5px;
        right: 12.5px;
    }
    
    .co-progress-line-fill {
        left: 12.5px;
    }
    
    .co-progress-line-fill.step2 {
        width: calc(50% - 12.5px);
    }
    
    .co-progress-line-fill.step3 {
        width: calc(100% - 25px);
    }
    
    .co-progress-indicator .step-item:nth-child(3) {
        left: 0;
    }
    
    .co-progress-indicator .step-item:nth-child(4) {
        left: 50%;
        transform: translateX(-50%);
    }
    
    .co-progress-indicator .step-item:nth-child(5) {
        right: 0;
        left: auto;
    }

    .sup-section-title {
        font-size: 18px;
    }

    .sup-form-row, .sup-summary-row {
        grid-template-columns: 1fr;
    }

    .sup-form-row label, .sup-summary-row .label {
        background-color: transparent;
        padding: 10px 0;
        font-size: 15px;
        border-bottom: 1px solid #eee;
    }
    
    .sup-form-row {
        border-bottom: none;
    }

    .sup-form-row .sup-form-field, .sup-form-row input, .sup-form-row div, .sup-form-row select, .sup-summary-row span:last-child {
        padding: 10px 0;
    }

    .sup-form-row input, .sup-form-row select {
        max-width: 100%;
        height: 45px;
    }

    .sup-form-row .sup-form-field {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    /* 모바일에서도 우편번호 행 값 영역 패딩을 다른 행과 동일하게 */
    .sup-form-row.sup-zip-row .sup-form-field {
        padding-left: 0;
        padding-right: 0;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .sup-form-field input, .sup-form-field select {
        width: 100% !important;
    }

    .sup-btn-inline {
        width: 100%;
        padding: 12px;
    }
    
    .biz-num .label-after, .phone-field .label-after {
        margin: 10px 0;
        text-align: center;
    }
    .sup-field-note {
        padding: 0 !important;
        grid-column: 1 / -1;
    }

    .sup-actions {
        flex-direction: column;
        gap: 10px;
    }
    
    .sup-actions.space-between {
        flex-direction: column-reverse;
    }
    
    .sup-btn-primary, .sup-btn-dark {
        width: 100%;
        padding: 15px;
    }
    .sup-final-container {
        padding: 60px 20px;
    }
}

/* 주소검색 모달 스타일 */
.address-search-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.address-search-modal {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
    max-height: 600px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.address-search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eee;
}

.address-search-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}

.address-search-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.address-search-close:hover {
    color: #333;
}

#address_search_layer {
    padding: 10px;
}

/* 에러 메시지 스타일 */
.sup-error-message {
    color: #E84100;
    font-size: 14px;
    margin-top: 5px;
    padding-left: 20px;
}

.sup-error-banner {
    background-color: #ffe6e6;
    color: #E84100;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
    border: 1px solid #ffc6c6;
} `, "",{"version":3,"sources":["webpack://./src/pages/css/SignUpPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,sDAAsD;AACtD;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA,0EAA0E;AAC1E;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,MAAM;AACV;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,MAAM;AACV;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,SAAO;IACP,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA,iBAAiB,YAAY,EAAE;AAC/B,wBAAwB,iBAAiB,EAAE;;AAE3C,qBAAqB,YAAY,EAAE;AACnC,4BAA4B,qBAAqB,EAAE;;;AAGnD;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA,4BAA4B;IAC5B;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA,sCAAsC;IACtC;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B","sourcesContent":[":root {\n    --primary: #e84200;\n    --red: #fa2d00;\n    --grey1: #d7d7d7;\n    --grey2: #d9d9d9;\n    --grey4: #a1a1a1;\n    --darkgrey1: #222222;\n    --darkgrey3: #000000;\n    --white: #ffffff;\n}\n\n.signup-page {\n    max-width: 1200px;\n    margin: 40px auto;\n    padding: 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.sup-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.sup-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.sup-main-title {\n    font-size: 32px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n/* Progress Indicator - 동일한 스타일을 CustomOrderPage와 공유 */\n.co-progress-indicator {\n    width: 466px;\n    max-width: 100%;\n    height: 90px;\n    position: relative;\n    margin: 40px auto;\n    padding: 0;\n}\n\n.co-progress-line-bg {\n    background: #d9d9d9;\n    width: calc(100% - 25px);\n    height: 3px;\n    position: absolute;\n    left: 12.5px;\n    right: 12.5px;\n    top: 12px;\n    z-index: 1;\n}\n\n.co-progress-line-fill {\n    background: var(--primary, #e84200);\n    width: 0;\n    height: 3px;\n    position: absolute;\n    left: 12.5px;\n    top: 12px;\n    z-index: 2;\n    transition: width 0.3s ease;\n}\n\n.co-progress-line-fill.step1 {\n    width: 0;\n}\n\n.co-progress-line-fill.step2 {\n    width: calc(50% - 12.5px);\n}\n\n.co-progress-line-fill.step3 {\n    width: calc(100% - 25px);\n}\n\n.co-progress-indicator .step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: absolute;\n    z-index: 3;\n    width: auto;\n}\n\n/* step-item 순서: (1)line-bg, (2)line-fill, (3)정보입력, (4)입력 내용 확인, (5)접수완료 */\n.co-progress-indicator .step-item:nth-child(3) {\n    left: 0;\n    top: 0;\n}\n\n.co-progress-indicator .step-item:nth-child(4) {\n    left: 50%;\n    transform: translateX(-50%);\n    top: 0;\n}\n\n.co-progress-indicator .step-item:nth-child(5) {\n    right: 0;\n    left: auto;\n    top: 0;\n}\n\n.step-dot {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: var(--grey2, #d9d9d9);\n    flex-shrink: 0;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.co-progress-indicator .step-item.active .step-dot,\n.step-dot.active {\n    background: var(--primary, #e84200);\n}\n\n.step-label {\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    white-space: nowrap;\n    min-width: 100px;\n    margin-left: -40px;\n}\n\n.sup-form-section {\n    margin-bottom: 50px;\n}\n\n.sup-section-title {\n    font-size: 20px;\n    font-weight: bold;\n    border-left: 4px solid #E84100;\n    padding-left: 10px;\n    margin-bottom: 20px;\n}\n\n.sup-form-grid, .sup-summary-grid {\n    border-top: 2px solid #333;\n    border-bottom: 1px solid #ddd;\n}\n\n.sup-form-row, .sup-summary-row {\n    display: grid;\n    grid-template-columns: 200px 1fr;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n}\n.sup-summary-row:last-child {\n    border-bottom: none;\n}\n\n.sup-form-row label, .sup-summary-row .label {\n    background-color: #f9f9f9;\n    padding: 20px;\n    font-weight: bold;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n}\n\n.sup-form-row .req {\n    color: #E84100;\n    margin-left: 4px;\n}\n\n.sup-form-row .sup-form-field, .sup-form-row input, .sup-form-row div, .sup-form-row select, .sup-summary-row span:last-child {\n    padding: 0;\n}\n\n.sup-form-row input, .sup-form-row select {\n    width: 100%;\n    max-width: 350px;\n    height: 40px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 0 10px;\n}\n\n.sup-form-row .sup-form-field {\n    padding: 0;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n/* 우편번호란: 다른 인풋 행과 동일한 좌측 패딩 유지 */\n.sup-form-row.sup-zip-row .sup-form-field {\n    padding-left: 0;\n    padding-right: 20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    box-sizing: border-box;\n}\n.sup-form-row.sup-zip-row .sup-form-field input {\n    flex: 1;\n    min-width: 0;\n    margin: 0;\n}\n\n.sup-btn-inline {\n    background-color: #333;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.biz-num input { width: 100px; }\n.biz-num .label-after { margin-left: 20px; }\n\n.phone-field input { width: 150px; }\n.phone-field .label-after { margin: 0 10px 0 20px; }\n\n\n.static-field {\n    gap: 20px !important;\n}\n.static-field p {\n    font-size: 14px;\n    color: #888;\n    margin: 0;\n}\n.sup-form-row .sup-field-note {\n    grid-column: 2 / 3;\n    padding-left: 20px;\n    padding-bottom: 10px;\n}\n\n.sup-field-note ul {\n    list-style-type: '•';\n    padding-left: 20px;\n    margin: 0;\n    color: #888;\n    font-size: 14px;\n    line-height: 1.6;\n}\n\n\n.sup-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 50px;\n    gap: 15px;\n}\n\n.sup-actions.space-between {\n    justify-content: space-between;\n}\n\n.sup-btn-primary {\n    background-color: #E84100;\n    color: white;\n    padding: 15px 80px;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.sup-btn-dark {\n    background-color: #333;\n    color: white;\n    padding: 15px 60px;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.sup-final-container {\n    text-align: center;\n    padding: 100px 0;\n}\n.sup-final-container h2 {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n.sup-final-container p {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 5px;\n}\n.sup-final-container button {\n    margin-top: 40px;\n    margin-right: 10px;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .signup-page {\n        margin: 20px auto;\n    }\n\n    .sup-main-title {\n        font-size: 28px;\n    }\n\n    .sup-form-row, .sup-summary-row {\n        grid-template-columns: 150px 1fr;\n    }\n\n    .sup-form-row input, .sup-form-row select {\n        max-width: 300px;\n    }\n\n    .sup-actions {\n        margin-top: 40px;\n    }\n\n    .sup-btn-primary {\n        padding: 12px 60px;\n    }\n\n    .sup-btn-dark {\n        padding: 12px 40px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .signup-page {\n        padding: 15px;\n        margin: 15px auto;\n    }\n\n    .sup-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .sup-main-title {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    /* 모바일에서도 데스크탑과 동일한 스타일 유지 */\n    .co-progress-indicator {\n        width: 466px;\n        max-width: 100%;\n        height: 90px;\n        margin: 40px auto;\n    }\n    \n    .co-progress-line-bg {\n        width: calc(100% - 25px);\n        left: 12.5px;\n        right: 12.5px;\n    }\n    \n    .co-progress-line-fill {\n        left: 12.5px;\n    }\n    \n    .co-progress-line-fill.step2 {\n        width: calc(50% - 12.5px);\n    }\n    \n    .co-progress-line-fill.step3 {\n        width: calc(100% - 25px);\n    }\n    \n    .co-progress-indicator .step-item:nth-child(3) {\n        left: 0;\n    }\n    \n    .co-progress-indicator .step-item:nth-child(4) {\n        left: 50%;\n        transform: translateX(-50%);\n    }\n    \n    .co-progress-indicator .step-item:nth-child(5) {\n        right: 0;\n        left: auto;\n    }\n\n    .sup-section-title {\n        font-size: 18px;\n    }\n\n    .sup-form-row, .sup-summary-row {\n        grid-template-columns: 1fr;\n    }\n\n    .sup-form-row label, .sup-summary-row .label {\n        background-color: transparent;\n        padding: 10px 0;\n        font-size: 15px;\n        border-bottom: 1px solid #eee;\n    }\n    \n    .sup-form-row {\n        border-bottom: none;\n    }\n\n    .sup-form-row .sup-form-field, .sup-form-row input, .sup-form-row div, .sup-form-row select, .sup-summary-row span:last-child {\n        padding: 10px 0;\n    }\n\n    .sup-form-row input, .sup-form-row select {\n        max-width: 100%;\n        height: 45px;\n    }\n\n    .sup-form-row .sup-form-field {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 10px;\n    }\n\n    /* 모바일에서도 우편번호 행 값 영역 패딩을 다른 행과 동일하게 */\n    .sup-form-row.sup-zip-row .sup-form-field {\n        padding-left: 0;\n        padding-right: 0;\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n\n    .sup-form-field input, .sup-form-field select {\n        width: 100% !important;\n    }\n\n    .sup-btn-inline {\n        width: 100%;\n        padding: 12px;\n    }\n    \n    .biz-num .label-after, .phone-field .label-after {\n        margin: 10px 0;\n        text-align: center;\n    }\n    .sup-field-note {\n        padding: 0 !important;\n        grid-column: 1 / -1;\n    }\n\n    .sup-actions {\n        flex-direction: column;\n        gap: 10px;\n    }\n    \n    .sup-actions.space-between {\n        flex-direction: column-reverse;\n    }\n    \n    .sup-btn-primary, .sup-btn-dark {\n        width: 100%;\n        padding: 15px;\n    }\n    .sup-final-container {\n        padding: 60px 20px;\n    }\n}\n\n/* 주소검색 모달 스타일 */\n.address-search-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.address-search-modal {\n    background: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n    max-height: 600px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.address-search-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n}\n\n.address-search-header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.address-search-close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #666;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.address-search-close:hover {\n    color: #333;\n}\n\n#address_search_layer {\n    padding: 10px;\n}\n\n/* 에러 메시지 스타일 */\n.sup-error-message {\n    color: #E84100;\n    font-size: 14px;\n    margin-top: 5px;\n    padding-left: 20px;\n}\n\n.sup-error-banner {\n    background-color: #ffe6e6;\n    color: #E84100;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    border: 1px solid #ffc6c6;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
